import React, {useEffect, useRef, useState} from 'react'
import PropTypes from 'prop-types';
import Tr from "translations/Translations";
import Dialog from "components/Dialog";
import {CircularProgress, List, ListItem, ListItemIcon, ListItemText} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";
import SingleButton from "../../popup/components/SingleButton";


import QueryBuilderIcon from '@material-ui/icons/QueryBuilder';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import Typography from "../../Typography";
import EzdrpService from "../../../services/EzdrpService";

const useStyle = makeStyles(theme => ({
    root: {},
    wait: {color: theme.palette.action.disabled},
    uploading: {
        color: theme.palette.primary.main,
    },
    done: {color: theme.palette.common.success},
    error: {color: theme.palette.common.error},

}))


function EzdrpDownloadPopup(
    {
        demandId,
        downloadFiles,
        handleSubmit,
        onUpload
    }) {
    const classes = useStyle();
    const [files, setFiles] = useState([]);
    const [working, setWorking] = useState(true);
    const uploadedFiles = useRef([]);
    const errorTranslate = Tr('file_response')

    useEffect(() => {
        setFiles(downloadFiles.files.map(x => ({...x})));
        (async () => {
            for (let i = 0; i < downloadFiles.files.length; i++) {
                setFiles(prev => {
                    const next = [...prev];
                    next[i].file = {uploadStatus: "UPLOADING"};
                    return next;
                })

                try {
                    const resp = await EzdrpService.downloadFileFromEzdrp(demandId, downloadFiles.files[i]);

                    if (resp.uploadStatus === 'OK') {
                        uploadSuccess({...resp, originalIndex: i});
                    }

                    setFiles(prev => {
                        const next = [...prev];
                        next[i].file = resp;
                        return next;
                    })
                } catch (e) {
                    console.error(e)
                    if (files && files[i])
                        setFiles(prev => {
                            const next = [...prev];
                            next[i].file = {uploadStatus: "ERROR"};
                            return next;
                        })
                }
            }
            setWorking(false);
        })()
        // eslint-disable-next-line
    }, [])

    const uploadSuccess = (fileData) => {
        uploadedFiles.current.push(fileData);
        if (onUpload)
            onUpload(fileData);
    };


    const getIcon = (file) => {
        if (!file.file) {
            return <QueryBuilderIcon className={classes.wait}/>
        } else if (file.file.uploadStatus === "UPLOADING") {
            return <CircularProgress className={classes.uploading} size={20}/>
        } else if (file.file.uploadStatus === "OK") {
            return <CheckCircleOutlineIcon className={classes.done}/>
        } else {
            return <ErrorOutlineIcon className={classes.error}/>
        }
    }

    const getSecondaryText = (file) => {
        if (file.file && file.file.uploadStatus !== "UPLOADING" && file.file.uploadStatus !== "OK") {
            return <Typography component="span" variant="body2" color="error">{errorTranslate[file.file.uploadStatus]}</Typography>
        }
    }

    const handleClose = () => {
        handleSubmit({
            files: uploadedFiles.current,
            config: downloadFiles.config
        })
    }

    return (
        <Dialog
            open
            maxWidth="md"
            dialogActions={
                <SingleButton onClick={handleClose} justify="flex-end" label={Tr('close')} disabled={working}/>
            }
        >

            <List dense>
                {files.map(x => (<ListItem key={x.uniqueId}>
                    <ListItemIcon>
                        {getIcon(x)}
                    </ListItemIcon>
                    <ListItemText
                        primary={x.name}
                        secondary={getSecondaryText(x)}

                    />
                </ListItem>))
                }
            </List>
        </Dialog>
    )
}

EzdrpDownloadPopup.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    downloadFiles: PropTypes.shape({
        files: PropTypes.arrayOf(PropTypes.shape({
            name: PropTypes.string.isRequired,
            serverRelativeUrl: PropTypes.string.isRequired,
            length: PropTypes.number.isRequired,
            uniqueId: PropTypes.string.isRequired
        })).isRequired,
        config: PropTypes.any
    }),
    handleSubmit: PropTypes.func.isRequired
}

export default EzdrpDownloadPopup;